import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AdministradoraAppRoutingModule } from "./administradora.app-routing.module";


@NgModule({
    imports: [
        CommonModule,     
        AdministradoraAppRoutingModule,   
    ],
    declarations: [
      
    ]
})
export class AdministradoraAppModule { }
